import { ReactNode } from 'react';
import CheckedIcon from '../icons/CheckedIcon.svg?react';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';

type PlanCardInfoRowType = {
  children: ReactNode;
};

export const PlanCardInfoRow = ({ children }: PlanCardInfoRowType) => {
  return (
    <Box display='flex' columnGap='8px' alignItems='start'>
      <CheckedIcon style={{ flexShrink: 0 }} />
      <Typography variant='bodySmall' color={COLORS.black}>
        {children}
      </Typography>
    </Box>
  );
};
